import MinutaCreateRead from '@/components/form/agreement/minuta-create-read'

export function GerarMinutaPage() {
  return <MinutaCreateRead />
}
